import { Navigate, useParams } from 'react-router-dom';

export function JoinRedirect() {
  const { inviteCode } = useParams<{ inviteCode?: string }>();

  const target = inviteCode
    ? `/apply?inviteId=${encodeURIComponent(inviteCode)}`
    : '/apply';

  return <Navigate to={target} replace />;
}
